<template>
    <div class="form-horizontal" v-if="!!user">
        <h1>Factuurgegevens</h1>
        <div class="form-group row">
            <label for="name" class="col-form-label col-md-4">Afdeling:</label>
            <div class="col-md-8">
                <input class="form-control-plaintext" id="invoiceDepartment" name="invoiceDepartment" disabled placeholder="Afdeling" v-model="profile.invoiceDepartment" /> 
            </div>
        </div>
        <div class="form-group row">
            <label for="invoiceAddress" class="col-form-label col-md-4">Factuuradres:</label>
            <div class="col-md-8">
                <input class="form-control-plaintext" id="invoiceAddress" name="invoiceAddress" disabled placeholder="Factuuradres" v-model="profile.invoiceAddress" /> 
            </div>
        </div>
        <div class="form-group row">
            <label for="invoicePostalCode" class="col-form-label col-md-4">Postcode:</label>
            <div class="col-md-8">
                <input class="form-control-plaintext" id="invoicePostalCode" name="invoicePostalCode" disabled placeholder="Postcode" v-model="profile.invoicePostalCode" /> 
            </div>
        </div>
        <div class="form-group row">
            <label for="invoiceCity" class="col-form-label col-md-4">Plaats:</label>
            <div class="col-md-8">
                <input class="form-control-plaintext" id="invoiceCity" name="invoiceCity" disabled placeholder="Plaats" v-model="profile.invoiceCity" /> 
            </div>
        </div>
        <hr>

        <div class="form-group row">
            <label for="invoicePhone" class="col-form-label col-md-4">Telefoonnummer:</label>
            <div class="col-md-8">
                <input class="form-control-plaintext" id="invoicePhone" name="invoicePhone" disabled placeholder="Telefoonnummer" v-model="profile.invoicePhone" /> 
            </div>
        </div>
        <div class="form-group row">
            <label for="invoiceEmail" class="col-form-label col-md-4">Email:</label>
            <div class="col-md-8">
                <input class="form-control-plaintext" id="invoiceEmail" name="invoiceEmail" disabled placeholder="Email" v-model="profile.invoiceEmail" /> 
            </div>
        </div>
        <div class="form-group row">
            <label for="invoiceIBAN" class="col-form-label col-md-4">IBAN:</label>
            <div class="col-md-8">
                <input class="form-control-plaintext" id="invoiceIBAN" name="invoiceIBAN" disabled placeholder="IBAN" v-model="profile.invoiceIBAN" /> 
            </div>
        </div>
        <div class="form-group row">
            <label for="invoiceBankAccountName" class="col-form-label col-md-4">Bankrekening Naam:</label>
            <div class="col-md-8">
                <input class="form-control-plaintext" id="invoiceBankAccountName" name="invoiceBankAccountName" disabled placeholder="Naam" v-model="profile.invoiceBankAccountName" /> 
            </div>
        </div>

        <hr>
        <div class="row">
            <div class="col-md-4 offset-md-2 text-center pr-5 pl-5 pt-5" v-if="profile.kvkDocumentId != null">
                <a href="#" title="Kamer van Koophandel">
                    <img src="@/assets/kvk.svg" class="img-fluid img-thumbnail rounded-circle" />
                </a>
            </div>
            <div class="col-md-4 text-center pr-5 pl-5 pt-5"  v-if="profile.annualReportId != null">
                <a href="#"  title="Jaarverslag">
                    <img src="@/assets/euro.png" class="img-fluid img-thumbnail rounded-circle" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['user'],
    computed: {
        profile() {
            if(this.user)
                return this.user.clientProfile;
            return {};
        },
    }
}
</script>

<style scoped>
.img-profile {
    width: 75%;
    height: 75%;
}
</style>

